module.exports = __webpack_public_path__ + "static/software-06fbd480e145de6e09e8c827fa77abc9.png";